import { RoleRegisterMessages, TranslationRoleRegisterMessages } from "../interfaces/roleRegisterMessages";

export const messages: TranslationRoleRegisterMessages = {
  [RoleRegisterMessages.titleCreate]: "Criar grupo",
  [RoleRegisterMessages.titleEdit]: "Editar grupo",
  [RoleRegisterMessages.stepTabFormRole]: "Dados do grupo",
  [RoleRegisterMessages.stepTabAddUsers]: "Adicionar usuários",
  [RoleRegisterMessages.noUsersRegistered]: "Não há usuários registrados",
  [RoleRegisterMessages.userIsAMemberOfAnotherRole]: "O usuário selecionado já pertence a outro grupo."
   + " Ao confirmar, ele passará a pertencer a este grupo."
};